import startCase from "lodash/fp/startCase";
import map from "lodash/fp/map";

class ManualInvoiceItemsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "Type", name: "name" },
      { title: "Category", name: "category" },
      { title: "Details", name: "tags" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.category = startCase(item.category);
      item.tags = map(startCase)(item.tags).join(", ");

      return item;
    };

    return map(format)(data);
  }
}

export default ManualInvoiceItemsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItems/manualInvoiceItems.transforms.js